import { Button, ButtonColorStyle } from '@wix/vmaf-adi-components';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

interface INextButtonProps extends WithTranslation {
  autoFocus?: boolean;
  form?: string;
  dataHook?: string;
  text?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  className?: string;
}

const NextButton: React.FC<INextButtonProps> = ({
  t,
  form,
  dataHook,
  text,
  onClick,
  disabled,
  autoFocus,
  className,
}) => (
  <nav>
    <Button
      className={className}
      autoFocus={autoFocus}
      form={form}
      dataHook={dataHook}
      colorStyle={ButtonColorStyle.COLORED}
      onClick={onClick}
      disabled={disabled}
    >
      {text || t('nav.next')}
    </Button>
  </nav>
);

NextButton.defaultProps = {
  dataHook: 'next-button',
};

export default withTranslation()(NextButton);
